import React from "react";
import { ProducaoPorcoesProvider } from "./context/ProducaoPorcoesContext";
import ProducaoPorcoesContent from "./components/ProducaoPorcoesContent";

const ProducaoPorcoes: React.FC = () => {
  return (
    <ProducaoPorcoesProvider>
      <ProducaoPorcoesContent />
    </ProducaoPorcoesProvider>
  );
};

export default ProducaoPorcoes;
